import * as React from 'react';
import { Scrollbars } from 'react-custom-scrollbars';

interface CustomScrollBarContainerProps {
  children: React.ReactNode;
  width?: string;
  height?: string;
  color?: string;
  thumbWidth?: string;
  heightMin?: string;
  heightMax?: string;
}

export default class CustomScrollBarContainer extends React.PureComponent<
  CustomScrollBarContainerProps
> {
  private scrollRef: React.RefObject<Scrollbars>;

  constructor(props: CustomScrollBarContainerProps) {
    super(props);
    this.scrollRef = React.createRef();
  }

  public scrollTop(value: number) {
    this.scrollRef.current!.scrollTop(value);
  }

  private readonly renderThumb = (style: any) => {
    const { thumbWidth, color } = this.props;
    const thumbStyle = {
      backgroundColor: color,
      borderRadius: '7px',
      width: thumbWidth,
    };
    return <div style={{ ...style, ...thumbStyle }} />;
  };

  public render() {
    const { width, height, children, heightMin, heightMax } = this.props;
    return (
      <div style={{ width, height, pointerEvents: 'none' }}>
        <Scrollbars
          ref={this.scrollRef}
          style={{ width: '100%', pointerEvents: 'all', display: 'inline-block' }}
          autoHide
          // autoHideTimeout={0}
          autoHideDuration={700}
          autoHeight
          autoHeightMin={heightMin !== undefined ? heightMin : 0}
          autoHeightMax={heightMax !== undefined ? heightMax : '100%'}
          thumbMinSize={30}
          renderThumbHorizontal={this.renderThumb}
          renderThumbVertical={this.renderThumb}
          hideTracksWhenNotNeeded
        >
          {children}
        </Scrollbars>
      </div>
    );
  }
}
